import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

/**
 * for this page
 */
import Header from '../../components/header';
import Footer from '../../components/footer';
import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { content } = this.props;

        const { nav, footer, search, surveyData } = content;
        const contentData = {
            search,
            surveyData,
        };

        return surveyData && surveyData.surveyinfo && surveyData.surveyinfo.isactive === '1' ? (
            <div className={styles.layout}>
                <Header content={nav} />
                <Content content={contentData} />
                <ChipEdit transform={transform} />
                <Footer content={footer} />
            </div>
        ) : (
            <div className={styles.request_no}>抱歉，该调查不存在，感谢您的关注!</div>
        );
    }
}

export default Layout;
